import React from "react";
import { Link } from "react-router-dom";
import { Icon, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { canCreateEvent } from "app/permissions";
import { t, Trans } from "app/utils";

import DuplicateEvent from "components/event/modals/DuplicateEvent";
import CancelEvent from "components/event/modals/CancelEvent";
import CheckInModal from "components/event/modals/CheckInModal";
import MessageGuests from "components/event/modals/MessageGuests";
import EventUnsubscribe from "components/event/modals/Unsubscribe";
import Event from "components/events/Event";

import QuickOptions from "components/display/QuickOptions";
import Flag from "components/common/Flag";

import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";

const getLinks = eventId => [
  {
    name: t("View Event"),
    icon: "android-calendar",
    target: `/events/${eventId}`,
    listOnly: true
  },
  {
    name: t("Edit Details"),
    icon: "edit",
    target: `/events/${eventId}/edit/type`,
    hostOnly: true,
    listOnly: true
  },
  {
    name: t("Edit Survey"),
    icon: "ios-list-outline",
    target: `/events/${eventId}/survey`,
    hostOnly: true,
    listOnly: true
  },
  {
    name: t("Add/Edit Expenses"),
    icon: "social-usd",
    target: `/events/${eventId}/expenses`,
    hostOnly: true,
    listOnly: true
  }
];

const ListItem = ({ link: { target, icon, name } }) => (
  <li>
    <Link to={target}>
      {icon && <Icon icon={icon} />}
      {name}
    </Link>
  </li>
);

const QuickLinks = ({
  event: eventAttributes,
  inList, userActivity,
  onEventUpdate,
  onUserActivityUpdate,
  onUserActivityRemove,
  onEventDelete
}) => {
  const { profile } = useProfile();

  const event = new Event(eventAttributes);
  const links = getLinks(event.id);
  const isHost = event.isUserHostOrAdmin(profile);

  return (
    <QuickOptions>
      <ul className="dropdown-menu">
        {profile.organizationAdmin && userActivity && (
          <li>
            <PinUserActivityToggle
              userActivity={userActivity}
              onUserActivityUpdate={onUserActivityUpdate}
            />
          </li>
        )}

        {links.map(link => {
          // Host & Admin Options
          if (link.hostOnly && !isHost) return null;
          if (link.listOnly && !inList) return null;

          // List Item
          return <ListItem link={link} key={link.name} />;
        })}

        {canCreateEvent(profile) && (inList || !event.isUserHostOrAdmin(profile)) && (
          <li>
            <DuplicateEvent event={event} />
          </li>
        )}
        {(isHost && inList) && (
          <>
            <li>
              <CancelEvent
                event={event}
                onEventUpdate={onEventUpdate}
                onUserActivityRemove={onUserActivityRemove}
                userActivity={userActivity}
                onEventDelete={onEventDelete}
              />
            </li>
            <li>
              <MessageGuests event={event} />
            </li>
            <li>
              <CheckInModal event={event} inList />
            </li>
          </>
        )}
        {!inList && (
          <li>
            <EventUnsubscribe event={event} />
          </li>
        )}
        <li>
          <Flag action="flagEvent" options={{ eventId: event.id }}>
            {onTrigger => (
              <PlainButton onClick={onTrigger}>
                <Icon icon="ios-flag" />
                <Trans>Flag event as inappropriate</Trans>
              </PlainButton>
            )}
          </Flag>
        </li>
      </ul>
    </QuickOptions>
  );
};

export default QuickLinks;
